import { updateSiteSettings } from '../../../actions/siteadmin/updateSiteSettings'
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';

async function submit(values, dispatch) {
    if (!values.ogImage) {
        return showToaster({ messageId: 'ogImageError', toasterType: 'error' })
    }
    await dispatch(updateSiteSettings(values));
}

export default submit;